export default __webpack_public_path__ + "static/media/animation-arrow5.8a42d86d.gif";